import { create } from 'zustand'
import { persist } from 'zustand/middleware'

/**
 * Read/dismissed state for the (derived) notification feed. The feed itself is
 * computed live from tasks + meetings, so we only need to remember which
 * derived notification ids the user has already seen. Persisted to localStorage.
 */
interface NotificationsReadState {
  read: string[]
  markRead: (id: string) => void
  markAllRead: (ids: string[]) => void
}

export const useNotificationsRead = create<NotificationsReadState>()(
  persist(
    (set) => ({
      read: [],
      markRead: (id) => set((s) => (s.read.includes(id) ? s : { read: [...s.read, id] })),
      markAllRead: (ids) => set((s) => ({ read: Array.from(new Set([...s.read, ...ids])) })),
    }),
    { name: 'mcsms.notifications.read' },
  ),
)
